import React, { useEffect, useState } from 'react';
import {
    Grid, Paper,
    useMediaQuery, Button, FormHelperText, Table, TableBody, TableCell, TableContainer,
    TableHead, TableRow, Checkbox,
} from '@mui/material';
import axios from 'axios';
import { useParams } from 'react-router-dom';


const StockClothBale = () => {
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const { clothId, locId } = useParams();
    const [stkCloths, setStkCloths] = useState([]);
    const [clothNm, setClothNm] = useState('');
    const [locNm, setLocNm] = useState('');
    const [totMtr, setTotMtr] = useState(0);

    useEffect(() => {
        const data = {
            clothId,
            locId
        }
        fetchStkCloths(data);
    }, [clothId, locId]);

    const fetchStkCloths = async (id) => {
        const { clothId, locId } = id
        try {
            const response = await axios.get(`${baseUrl}?apicall=getClothGivenUsedList&clothId=${clothId}&locId=${locId}`);
            const res = response?.data;
            const clothnm = res?.stockcloths[0]?.clothNm;
            const locNm = res?.stockcloths[0]?.locNm;
            setLocNm(locNm);
            setClothNm(clothnm);
            setStkCloths(res?.stockcloths);
            const totmtr = res?.stockcloths?.reduce((acc, sum) => acc + parseFloat(sum.mtr), 0);
            setTotMtr(totmtr.toFixed(2));
        } catch (error) {
            console.error('Error fetching info list:', error);
        }
    };


    const tableContainerStyle = {
        marginTop: '1%',
        overflow: 'hidden',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none',
    };

    const webkitScrollbarStyle = {
        overflowX: 'auto',
        overflowY: 'hidden',
        WebkitOverflowScrolling: 'touch',
    };
    return (
        <>
            <div style={{ margin: '3%' }}>

                <Grid container spacing={2}>
                    <h2>Stock Mtr.</h2>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '3vh', margin: '0' }}>
                            <h3>Cloth : {clothNm}</h3>
                            <br />
                            <h3>Location : {locNm}</h3>

                            {Array.isArray(stkCloths) && stkCloths?.length > 0 &&
                                <>
                                    <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle }}>
                                        <Table>
                                            <TableHead>
                                                <TableRow className='tbl-row'>

                                                    <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>Sr.No.</TableCell>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>Date</TableCell>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>Bale No.</TableCell>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>Stock Mtr.</TableCell>
                                                    {/* <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>Bal Mtr.</TableCell> */}
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {stkCloths.length > 0 ? (
                                                    stkCloths.map((item, index) => (
                                                        <TableRow key={index}>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>{index + 1}</TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>{item.dt}</TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>{item.bale}</TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>{item.mtr}</TableCell>
                                                            {/* <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>{item.bmtr}</TableCell> */}
                                                        </TableRow>
                                                    ))
                                                ) : null}

                                                <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'> </TableCell>
                                                <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'> </TableCell>
                                                <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px', fontWeight: 'bold' }} align='center'>Total Mtr.</TableCell>
                                                <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px', fontWeight: 'bold' }} align='center'>{totMtr}</TableCell>

                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </>
                            }
                        </Paper>
                    </Grid>
                </Grid>
            </div>
        </>
    );
}

export default StockClothBale;
